import { Amplify } from 'aws-amplify'
import { once } from 'lodash'
import { amplifyConfig } from '../config'

const configAmplify = () => {
    return Amplify.configure(amplifyConfig)
}

export const startAmplifyOnce = once(configAmplify)
export const startAmplify = startAmplifyOnce
